import { QueryProvider } from "@/api/QueryProvider";
import { supabaseConfigError } from "@/api/supabaseClient";
import { AuthGate } from "@/auth/AuthGate";
import { AuthProvider } from "@/auth/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { RootReloadFallback } from "@/components/RootReloadFallback";
import { NetworkProvider } from "@/network/NetworkContext";
import { ThemeProvider } from "@/theme/ThemeProvider";
import { SupabaseConfigErrorScreen } from "@/ui/components/SupabaseConfigErrorScreen";
import { Stack } from "expo-router";
import Head from "expo-router/head";
import { Platform, View } from "react-native";
import Toast from "react-native-toast-message";

const webRootStyles = `
  html, body, #root { height: 100%; min-height: 100vh; min-height: 100dvh; max-width: 100%; overflow-x: hidden; }
  body { margin: 0; overflow: hidden; }
  #root { display: flex; flex-direction: column; width: 100%; max-width: 100%; }
  [data-fc-shell] {
    min-height: 100vh;
    min-height: 100dvh;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
  input, textarea, select { max-width: 100%; min-width: 0; }
  input[data-de-date]:not(:focus) { color: transparent; }
  input[data-de-date][data-scheme="dark"] { color-scheme: dark; }
`;

export default function RootLayout() {
  return (
    // Root-Boundary außerhalb von Auth und Query. Fallback nur „Neu laden“.
    <ErrorBoundary
      fallback={(_error, resetError) => <RootReloadFallback resetError={resetError} />}
    >
    <ThemeProvider>
      {Platform.OS === "web" && (
        <Head>
          <meta name="google" content="notranslate" />
          <style dangerouslySetInnerHTML={{ __html: webRootStyles }} />
        </Head>
      )}
      {supabaseConfigError ? (
        <SupabaseConfigErrorScreen error={supabaseConfigError} />
      ) : (
        <QueryProvider>
          <NetworkProvider>
            <AuthProvider>
              <View
                style={
                  Platform.OS === "web"
                    ? {
                        flex: 1,
                        width: "100%" as unknown as number,
                        position: "relative" as const,
                      }
                    : { flex: 1 }
                }
              >
                <AuthGate>
                  <Stack screenOptions={{ headerShown: false }} />
                  <Toast />
                </AuthGate>
              </View>
            </AuthProvider>
          </NetworkProvider>
        </QueryProvider>
      )}
    </ThemeProvider>
    </ErrorBoundary>
  );
}
